<template>
	<div class="fill-height">
		<div class="d-flex flex-column justify-center align-center fill-height flex-1" v-if="loadingRoomMessages">
			<div class="d-flex flex-column justify-center align-center fill-height flex-1">
				<v-progress-circular
					:size="50"
					:width="5"
					color="rgba(0,0,0,0.2)"
					class="mb-3"
					indeterminate
				></v-progress-circular>
				Cargando Mensajes
			</div>
		</div>
		<div v-else-if="fileToUpload || previewFile" class="d-flex flex-column flex-grow-1 fill-height">
		<div class="d-flex align-center justify-space-between mb-2 py-1 px-2">
			<div class="d-flex align-center">
				<p class="mb-0 caption font-weight-bold">Previsualización Archivo</p>
			</div>
			<v-btn
				depressed
				color="#524D4D"
				icon
				class="ml-2"
				@click="closeFilePreview"
			>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</div>
		<FileViewer :selectedFile="fileToUpload || previewFile"/>
		<div class="user-input-container" v-if="fileToUpload">
			<v-progress-linear indeterminate v-if="loadingAddChat"></v-progress-linear>
			<div class="user-input-inner-container">
				<v-text-field
					ref="messageInput"
					v-model="new_message"
					placeholder="Escribe un mensaje"
					hide-details
					dense
					outlined
					required
					:disabled="loadingAddChat"
					@keydown.enter="sendMessage"
				>
					<template v-slot:append-outer>
						<v-btn small fab color="green" dark @click="sendMessage">
							<v-icon>mdi-send</v-icon>
						</v-btn>
					</template>
				</v-text-field>
			</div>
		</div>
	</div>
	<div v-else class="d-flex flex-column flex-grow-1" :style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="chat-room-header d-flex align-center">
			<div class="py-1 px-1 fill-height d-flex align-center justify-center" style="width: 160px;" :style="getRoomTypeStyle">
				<div class="text-center">
					<p class="mb-0 body-2 font-weight-bold" v-if="getRoomTypeIndicator == 'project_line'">LP{{ roomPlNumber }}</p>
					<img :src="roomAvatar" class="user-avatar" v-else-if="roomAvatar"/>
					<p class="mb-0" style="font-size: 10px;">{{ getRoomType }}</p>
				</div>
			</div>
			<div class="d-flex justify-space-between flex-1 py-1 px-2">
				<div>
					<p class="mb-0 font-weight-bold">{{ roomName }}</p>
					<p class="mb-0 caption">{{ roomAddress }}</p>
				</div>
				<UserManagment :chatRoom="chatRoom" @reload="reloadChatRoom" v-if="!isUserRoom && chatRoom" />
			</div>
		</div>
		<div v-if="chatRoom.included_project_lines?.length > 0" class="d-flex align-center justify-start pa-0" style="border-bottom: 1px solid #ededed;background-color: #f2f2f2;">
			<v-btn-toggle
				v-model="project_line_id"
				dense
				tile
				class="d-flex flex-row custom-toggle-btns"
			>
				<v-btn :value="null" class="flex-grow-1"
					:color="project_line_id == null ? '#FF120B':''">
					<div>
						<p class="mb-0 caption font-weight-bold" :class="project_line_id == null ? 'white--text':''">Ver Otros</p>
						<p class="mb-0 font-weight-bold" style="font-size: 9px;line-height: 9px" :class="project_line_id == null ? 'white--text':''">Sin Línea de Proyecto</p>
						<div v-if="getUnseenMessageCountForOthers() > 0" class="custom-badge-counter-chat">
							<p class="mb-0 white--text" :style="{ fontSize: getUnseenMessageCountForOthers() > 10 ? '10px' : '12px' }">{{ getUnseenMessageCountForOthers() > 99 ? '+99' : getUnseenMessageCountForOthers() }}</p>
						</div>
					</div>
				</v-btn>
				<v-btn 
					v-for="(pl, index) in chatRoom.included_project_lines"
					:key="'chat_pl-'+index"
					:value="pl.id"
					class="flex-grow-1"
					:color="project_line_id == pl.id ? '#FF120B':''">
					<div class="px-1" style="position: relative;">
						<p class="mb-0 caption font-weight-bold" :class="project_line_id == pl.id ? 'white--text':''">{{ getProjectLineName(pl) }}</p>
						<p class="mb-0 font-weight-bold" style="font-size: 10px;line-height: 10px" :class="project_line_id == pl.id ? 'white--text':''">LP{{ pl.number }}</p>
						<div v-if="getUnseenMessageCountForProjectLine(pl.id) > 0" class="custom-badge-counter-chat">
							<p class="mb-0 white--text" :style="{ fontSize: getUnseenMessageCountForProjectLine(pl.id) > 10 ? '10px' : '12px' }">{{ getUnseenMessageCountForProjectLine(pl.id) > 99 ? '+99' : getUnseenMessageCountForProjectLine(pl.id) }}</p>
						</div>
					</div>
				</v-btn>
			</v-btn-toggle>
			<v-menu ref="userProjectsMenu" offset-y v-if="filteredUserProjects && filteredUserProjects.length > 0" @input="projectSearch = ''" content-class="white-menu-content">
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						tile
						depressed
						class="flex-grow-1"
						max-width="170px"
						:color="filteredUserProjects.some(pl => pl.id === project_line_id) ? '#FF120B':''"
						v-bind="attrs"
						v-on="on">
						<div>
							<p class="mb-0 caption font-weight-bold" :class="filteredUserProjects.some(pl => pl.id === project_line_id) ? 'white--text':''">Otras LP</p>
							<p class="mb-0 font-weight-bold" style="font-size: 9px;line-height: 9px" :class="filteredUserProjects.some(pl => pl.id === project_line_id) ? 'white--text':''">Líneas de Proyecto Sin Chat</p>
						</div>
					</v-btn>
				</template>
				<div style="background-color: white;">
					<div class="pa-2" style="border-bottom: 1px solid #eee;" @click.stop>
						<div class="d-flex align-center justify-center mb-0 mx-2">
							<v-icon color="#524D4D">mdi-magnify</v-icon>
							<v-text-field
								v-model="projectSearch"
								outlined
								dense
								hide-details
								return-object
								clearable
								label="Buscar línea de proyecto"
								class="mb-0 custom-height-search custom-height-calendar"
								color="#524D4D"
							></v-text-field>
						</div>
					</div>
					<v-list dense style="max-height: 300px; overflow-y: auto;">
						<v-list-item 
							v-for="(pl, index) in filteredUserProjects"
							:key="'user_pl-'+index"
							@click="selectUserProject(pl)"
						>
							<v-list-item-content>
								<v-list-item-title>{{ getProjectLineName(pl) }}</v-list-item-title>
								<v-list-item-subtitle>LP{{ pl.number }}</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
						<v-list-item v-if="filteredUserProjects.length === 0" disabled>
							<v-list-item-content>
								<v-list-item-title class="text-center caption text--secondary">No se encontraron resultados</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</div>
			</v-menu>
		</div>
		<div ref="chatContainer" class="chat-container d-flex flex-column flex-grow-1" style="overflow:scroll; max-height: 100%;">
			<div class="messages-container" ref="messagesContainer" v-if="filteredMessages.length > 0">
				<div v-for="(message, index) in filteredMessages" :key="index" class="message-group d-flex flex-column">
					<v-divider v-if="shouldShowRelatableDivider(index)" class="my-1"></v-divider>
					<div v-if="shouldShowRelatableHeader(index)" class="d-flex align-center justify-center pt-1 mb-1" style="gap: 10px;background-color: #f2f2f2;">
						<p class="mb-1 caption font-weight-bold"><span class="text--secondary">[LP{{ getRelatableId(message) }}]</span> {{getProjectLineName(message.relatable?.relatable)}}</p>
						<ProjectLineAssociationMenu v-if="message.relatable?.relatable_type == 'App\\Models\\ProjectLine'" :projectLineAssociations="getRelatableAssociations(message)" />
					</div>
					<div v-if="message.system_message" class="system-message my-1">
						<div
							v-html="message.message"
							class="d-flex align-center justify-center" style="gap: 4px;">
						</div>
						<p class="mb-0 text-center">
							{{message.created_at | toDateTime}}
						</p>
					</div>
					<div v-else class="single-message my-1" :class="isMyMessage(message) ? 'self-user':''">
						<div class="d-flex align-center justify-space-between">
							<p v-if="!isMyMessage(message)" class="mb-0 font-weight-bold" style="font-size: 11px; line-height: 10px;" :style="{color: message?.user ? getUserColor(message.user.user_id) : 'inherit'}">{{getMessageName(message)}}</p>
						</div>
						<div
							v-if="message.file && getIconFile(message.file).icon != 'mdi-file-image'"
							class="chat-file-container rounded d-flex justify-center align-center pa-1"
							@click="previewFile = message.file"
						>
							<v-icon :color="getIconFile(message.file).color" large>{{getIconFile(message.file).icon}}</v-icon>
							<p class="mb-0 mt-2 caption text-center truncate-text">{{message.file.name}}</p>
						</div>
						<div v-else-if="message.file" @click="previewFile = message.file">
							<div class="chat-image-container mt-1">
								<v-img
									:src="message.file.file_link"
									contain
									width="200px"></v-img>
							</div>
						</div>

						<div class="d-flex align-start" v-if="message.message">
							<p class="mb-0 mr-4 mt-1" style="text-transform: none;">{{message?.message}}</p>
							<v-btn color="error" icon small v-if="isMyMessage(message) && !chatRoom.user_is_trashed" @click="deleteChatMessage(message.id)">
								<v-icon small>mdi-delete-outline</v-icon>
							</v-btn>
						</div>
						<div class="text-right caption text--secondary">
							<small>{{message.created_at | toDateTime}}</small>
						</div>
					</div>
				</div>
			</div>
			<div class="messages-container nomessages" v-else>
				<span v-if="project_line_id && !showAllMessages && !hasMessagesWithProjectLine">
					<div class="d-flex flex-column align-center">
						<p class="mb-1 font-weight-bold">No hay mensajes para esta línea de proyecto</p>
						<p class="caption text--secondary">Sé el primero en escribir un mensaje para esta línea de proyectos</p>
					</div>
				</span>
				<span v-else>Escribe un mensaje para iniciar la conversación</span>
			</div>
		</div>
		<div class="user-input-container text-center px-2 py-3" v-if="chatRoom.user_is_trashed">
			<p class="mb-0 caption text--secondary">No puedes enviar mensajes en este chat</p>
		</div>
		<div class="user-input-container" v-else>
			<v-progress-linear indeterminate v-if="loadingAddChat"></v-progress-linear>
			<div class="user-input-inner-container">
				<v-text-field
					ref="messageInput"
					v-model="new_message"
					placeholder="Escribe un mensaje"
					hide-details
					dense
					outlined
					required
					:disabled="loadingAddChat"
					@keydown.enter="sendMessage"
				>
					<template v-slot:append-outer>
						<div class="px-2 py-0">
							<v-menu offset-y>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										:loading="loadingAddChat"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon>mdi-paperclip</v-icon>
									</v-btn>
								</template>
								<v-list dense>
									<v-list-item @click="openProjectFileSelector">
										<v-list-item-icon class="mr-2">
											<v-icon small>mdi-folder-open</v-icon>
										</v-list-item-icon>
										<v-list-item-title>Desde archivos del proyecto</v-list-item-title>
									</v-list-item>
									<v-list-item @click="showFilePicker">
										<v-list-item-icon class="mr-2">
											<v-icon small>mdi-file</v-icon>
										</v-list-item-icon>
										<v-list-item-title>Desde mis archivos</v-list-item-title>
									</v-list-item>
								</v-list>
							</v-menu>
							<input 
								type="file" 
								ref="fileInput"
								style="display: none;"
								:accept="acceptedFileTypes"
							/>
						</div>
						<v-btn icon @click="sendMessage">
							<v-icon>mdi-send</v-icon>
						</v-btn>
					</template>
				</v-text-field>
			</div>
		</div>
		</div>
		<ChatProjectFileSelector
			v-if="showFileSelector && chatRoom?.morphable_id"
			:projectId="chatRoom.morphable_id"
			@file-selected="handleFileSelected"
		/>
	</div>
</template>

<script>
import {getChatRoomMessages, addMessageToChatRoom, chatFileToItem, deleteMessageFromChatRoom, markMessagesAsSeen} from '@/helpers/api/chats'
import FileViewer from '@/components/Views/PreProjects/Sections/FileViewer'
import ChatProjectFileSelector from '@/components/Views/Chat/Parts/ChatProjectFileSelector'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import UserManagment from '@/components/Views/Chat/UserManagment'
import ProjectLineAssociationMenu from '@/components/Views/Projects/Parts/ProjectLineAssociationMenu'

export default {
	name: 'MessagesFullView',
		components: {FileViewer, UserManagment, ProjectLineAssociationMenu, ChatProjectFileSelector},
	props: {
		selectedChatRoomId: {
			type: Number,
			required: true
		}
	},
	data() {
		return {
			search: '',
			new_message: null,
			loadingAddChat: false,
			loadingRoomMessages: true,
			chatRoom: null,
			conversationMessages: [],
			requestInterval: null,
			fileToUpload: null,
			previewFile: null,
			menuOpen: false,
			project_line_id: null,
			showAllMessages: false,
			userProjects: null,
			showFileSelector: false,
			projectSearch: '',
			userColorMap: {},
			colorPalette: [
				"#C92A2A",
				"#A61E4D",
				"#862E9C",
				"#5F3DC4",
				"#364FC7",
				"#1864AB",
				"#0B7285",
				"#087F5B",
				"#2B8A3E",
				"#5C940D",
				"#E67700",
				"#D9480F",
				"#B02A37",
				"#7B2CBF",
				"#3A0CA3",
				"#1D4ED8",
				"#1E40AF",
				"#155E75",
				"#065F46",
				"#166534",
				"#4D7C0F",
				"#92400E",
				"#9A3412",
				"#7F1D1D",
				"#701A75",
				"#4C1D95",
				"#1E3A8A",
				"#0C4A6E",
				"#134E4A",
				"#14532D"
			]
		};
	},
  computed: {
		isClient(){
			return this.$checkPermissions(['client_capabilities'])
		},
		isUserRoom(){
			return this.chatRoom.morphable_type == "App\\Models\\User"
		},
		filteredMessages(){
			if(!this.project_line_id || this.showAllMessages && this.conversationMessages && this.conversationMessages.length > 0){
				return this.conversationMessages.filter(message => {
					return !message?.relatable
				})
			}
			return this.conversationMessages.filter(message => {
				return parseInt(message?.relatable?.relatable_id) === parseInt(this.project_line_id)
			})
		},
		hasMessagesWithProjectLine(){
			if(!this.project_line_id) return false
			return this.conversationMessages.some(message =>
				parseInt(message?.relatable?.relatable_id) === parseInt(this.project_line_id)
			)
		},
		otherProjectMessagesCount(){
			if(!this.project_line_id) return 0
			return this.conversationMessages.filter(message => {
				const rid = message?.relatable?.relatable_id
				return !rid || parseInt(rid) !== parseInt(this.project_line_id)
			}).length
		},
		getRoomType(){
			if(this.chatRoom.morphable?.associations?.every(assoc => {
																											const conv = assoc.morphable;
																											return conv?.user && !conv?.client;
																										})
				){
				return 'Chat Prospecto'
			}
			else if(this.chatRoom.morphable_type == "App\\Models\\User" && this.chatRoom.morphable?.company_rol?.role_id == 4){
				return 'Chat Cliente'
			}
			else if(this.chatRoom.morphable_type == "App\\Models\\User" && this.chatRoom.morphable?.company_rol?.capabilities?.subcontractor){
				return 'Chat Subcontratista'
			}
			else if(this.chatRoom.morphable_type == "App\\Models\\User" && this.chatRoom.morphable?.company_rol?.role_id != 4){
				return 'Chat Profesionales / Empresas'
			}
			else if (this.chatRoom.morphable_type == "App\\Models\\ProjectLine"){
				return 'Chat Grupal Proyecto'
			}
			return 'Otro'
		},
		getRoomTypeStyle(){
			if(this.chatRoom.morphable?.associations?.every(assoc => {
																											const conv = assoc.morphable;
																											return conv?.user && !conv?.client;
																										})
				){
				return 'background-color:white; color:black; border: 1px solid black;'
			}
			else if(this.chatRoom.morphable_type == "App\\Models\\User" && this.chatRoom.morphable?.company_rol?.role_id == 4){
				return 'background-color:black;color: white;'
			}
			else if(this.chatRoom.morphable_type == "App\\Models\\User" && this.chatRoom.morphable?.company_rol?.role_id != 4){
				return 'background-color:#524d4d;color: white;'
			}
			else if (this.chatRoom.morphable_type == "App\\Models\\ProjectLine"){
				return 'background-color:#FF120B;color: white;'
			}
			return 'background-color:#808080;color: white;'
		},
		roomName(){
			if(this.chatRoom.name){
				return `${this.chatRoom.name}`
			}
			if(this.chatRoom.morphable_type == "App\\Models\\User"){
				return this.chatRoom.morphable.profile?.name + ' ' + this.chatRoom.morphable.profile?.lastname + ' ' + this.chatRoom.morphable.profile?.second_lastname
			}
			const project_name = this.chatRoom.morphable?.associations.reduce((acc, item) => {
				return acc || item.morphable.name || item.morphable.info?.project_details;
			}, null)
			return `${project_name}`
		},
		roomAddress(){
			if(this.chatRoom.morphable_type == "App\\Models\\User"){
				return this.chatRoom.morphable.email
			}
			const project_address = this.chatRoom.morphable?.associations.reduce((acc, item) => {
				return acc || item.morphable?.info?.address?.address
			}, null)
			return project_address
		},
		roomAvatar(){
			if(this.chatRoom.morphable_type == "App\\Models\\User"){
				return this.chatRoom.morphable.profile?.avatar
			}
			return null
		},
		roomPlNumber(){
			return this.chatRoom.morphable?.number || null
		},
		getRoomTypeIndicator(){
			if(this.chatRoom.morphable?.associations?.every(assoc => {
																											const conv = assoc.morphable;
																											return conv?.user && !conv?.client;
																										})
				){
				return 'prospect'
			}
			else if(this.chatRoom.morphable_type == "App\\Models\\User" && this.chatRoom.morphable?.company_rol?.role_id == 4){
				return 'client'
			}
			else if(this.chatRoom.morphable_type == "App\\Models\\User" && this.chatRoom.morphable?.company_rol?.role_id != 4){
				return 'professional'
			}
			else if (this.chatRoom.morphable_type == "App\\Models\\ProjectLine"){
				return 'project_line'
			}
			return 'other'
		},
		queryRoute(){
			return this.$route.query
		},
    preproject() {
      return this.$store.state.preprojects.preProject
    },
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		roomAdmin(){
			return this.chatRoom.users.find((user) => user.admin == true)
		},
		acceptedFileTypes() {
			return [
				'application/pdf', 
				'application/msword', 
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
				'application/vnd.ms-excel', 
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
				'image/jpeg', 
				'image/png', 
				'image/gif', 
				'image/bmp', 
				'image/svg+xml'
			].join(',');
		},
		projectLineClient(){
			return this.chatRoom.morphable?.associations?.find(assoc => 
				assoc.morphable?.client
			)?.morphable?.client
		},
		projectLineClientName(){
			const client = this.projectLineClient
			if(client){
				return client.profile?.name + ' ' + client.profile?.lastname + ' ' + client.profile?.second_lastname
			}
			return null
		},
		filteredUserProjects(){
			if(!this.userProjects) return []
			// Excluir las líneas de proyecto que ya están en el chat
			const includedIds = this.chatRoom?.included_project_lines?.map(pl => pl.id) || []
			const filtered = this.userProjects.filter(pl => !includedIds.includes(pl.id))
			
			if(!this.projectSearch) return filtered
			const search = this.projectSearch.toLowerCase()
			return filtered.filter(pl => {
				const projectName = this.getProjectLineName(pl).toLowerCase()
				const projectNumber = (pl.number || '').toString()
				return projectName.includes(search) || projectNumber.includes(search)
			})
		}
  },
	watch: {
		filteredMessages(newValue){
			if (newValue && newValue.length > 0) {
				const unseenMessageIds = newValue
					.filter(msg => msg.id && (!msg.seen_message || msg.seen_message.length === 0))
					.map(msg => msg.id);
				
				if (unseenMessageIds.length > 0) {
					this.markMessagesAsSeenBatch(unseenMessageIds);
				}
			}
			this.$nextTick(() => {
				this.scrollToBottom()
			})
		},
		queryRoute(){
			const chat_room_id = this.$route.query.id
			const project_line_id = this.$route.query.project_line_id
			if(chat_room_id && this.selectedChatRoomId == chat_room_id){
				this.getSelectedChatRoomMessages()
			}
			if(project_line_id && parseInt(project_line_id) !== this.project_line_id){
				this.project_line_id = parseInt(project_line_id)
			}else if (!project_line_id){
				this.project_line_id = null
			}
		},
		chatsRooms(newValue){
			if(newValue && newValue.length > 0 && parseInt(this.$route.query.user_id)){
				this.selectRoomFromSearch({id: parseInt(this.$route.query.user_id)})
			}
		},
		conversationMessages(newValue){
			if(newValue){
				this.scrollToBottom()
			}
		},
		selectedCompany(newValue){
			if(newValue){
				this.$store.dispatch('chats/getUserChats')
				this.$store.dispatch('users/getUserFromCompany', {start: 0, limit: 300})
			}
		},
		selectedChatRoomId(newValue, oldValue){
			if(newValue && newValue != oldValue){
				this.getSelectedChatRoomMessages()
			}
		}
	},
	beforeDestroy(){
		eventBus.$off('reloadChat', this._onReloadChat)
	},
	mounted(){
		this.scrollToBottom()
		const projectLineId = this.$route.query.project_line_id || this.$route.params.project_line_id || null
		this.project_line_id = projectLineId ? parseInt(projectLineId) : null
		if(this.selectedCompany){
			this.$store.dispatch('chats/getUserChats')
			this.$store.dispatch('users/getUserFromCompany', {start: 0, limit: 300})
		}
		
		if(this.selectedChatRoomId){
			this.getSelectedChatRoomMessages()
		}
    eventBus.$on('reloadChat', this._onReloadChat)
	},
	methods: {
		assignColorsToUsers(users) {
			// const colorMap = localStorage.getItem('chatUserColorMap_' + this.chatRoom.id)
			// if (colorMap) {
			// 	this.userColorMap = JSON.parse(colorMap)
			// 	return
			// }
			const sorted = [...users].sort((a, b) => a.user_id - b.user_id)
			const newMap = {}
			const availableColors = [...this.colorPalette];
			sorted.forEach(user => {
				if (user && user.user_id && availableColors.length) {
					if(this.projectLineClient && user.user_id === this.projectLineClient.id){
						newMap[user.user_id] = 'black'
						return
					}
					const index = Math.floor(Math.random() * availableColors.length);
					newMap[user.user_id] = availableColors.splice(index, 1)[0];
				}
			});
			this.userColorMap = newMap
			localStorage.setItem('chatUserColorMap_' + this.chatRoom.id, JSON.stringify(newMap))
		},
		getUserColor(userId) {
			return this.userColorMap[userId] || '#9E9E9E'
		},
		getUnseenMessageCountForProjectLine(projectLineId){
			if(!this.conversationMessages || this.conversationMessages?.length === 0) return 0
			return this.conversationMessages
				.filter(msg => {
					return parseInt(msg?.relatable?.relatable_id) === parseInt(projectLineId) && (!msg.seen_message || msg.seen_message.length === 0)
				})
				.length
		},
		getUnseenMessageCountForOthers() {
			return this.conversationMessages.filter(msg => {
				const relatable_id = msg?.relatable?.relatable_id
				const isProjectLine = this.chatRoom.included_project_lines?.some(pl => pl.id === parseInt(relatable_id))
				return !isProjectLine && (!msg.seen_message || msg.seen_message.length === 0)
			}).length
		},
		getProjectLineName(pl){
			const assoc = pl.associations?.find(assoc => assoc.morphable?.name || assoc.morphable?.info?.project_detail);
			return assoc?.morphable?.name || assoc?.morphable?.info?.project_detail || '--';
		},
		reloadChatRoom(){
			this.getSelectedChatRoomMessages()
		},
		selectUserProject(pl){
			this.project_line_id = pl.id
			this.$refs.userProjectsMenu.isActive = false
		},
		clearProjectLineFilter(){
			this.project_line_id = null
			this.showAllMessages = false
			const query = { ...this.$route.query }
			delete query.project_line_id
			this.$router.replace({ query })
		},
		getRelatableId(message){
			return message?.relatable?.relatable_id || null
		},
		getRelatableAssociations(message){
			if(message?.relatable?.relatable?.associations){
				return {
					associations: message.relatable.relatable.associations,
					project_line_id: message.relatable.relatable.id
				}
			}
			return null
		},
		shouldShowRelatableHeader(index){
			if(this.project_line_id && !this.showAllMessages && this.hasMessagesWithProjectLine){
				return index === 0;
			}
			
			const currentMessage = this.filteredMessages[index];
			const previousMessage = index > 0 ? this.filteredMessages[index - 1] : null;
			
			const currentRelatableId = this.getRelatableId(currentMessage);
			const previousRelatableId = previousMessage ? this.getRelatableId(previousMessage) : null;
			
			return !!currentRelatableId && currentRelatableId !== previousRelatableId;
		},
		shouldShowRelatableDivider(index){
			if(this.project_line_id && !this.showAllMessages && this.hasMessagesWithProjectLine){
				return false;
			}
			
			const currentMessage = this.filteredMessages[index];
			const previousMessage = index > 0 ? this.filteredMessages[index - 1] : null;
			
			if (index === 0 || !previousMessage) return false;
			
			const currentRelatableId = this.getRelatableId(currentMessage);
			const previousRelatableId = this.getRelatableId(previousMessage);
			
			return currentRelatableId !== previousRelatableId;
		},
		getMessageName(message){
			if(message?.user){
				return message?.user?.name + ' ' + message?.user?.lastname + ' ' + message?.user?.second_lastname
			}
			return this.roomName
		},
		_onReloadChat() {
			if(this.selectedChatRoomId){
				this.getSelectedChatRoomMessages()
			}
		},
		scrollToBottom() {
			this.$nextTick(() => {
				const container = this.$refs.chatContainer;
				if (container) {
					container.scrollTop = container.scrollHeight;
				}
			})
		},
		closeFilePreview(){
			this.fileToUpload = null
			this.previewFile = null
		},
		openProjectFileSelector(){
			if (this.chatRoom?.morphable_id) {
				this.showFileSelector = true
			} else {
				const messageData = {
					message: 'No se pudo identificar el proyecto asociado',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		async handleFileSelected(file){
			const data = {
				chat_room_id: this.selectedChatRoomId,
				message: '',
				file_id: file.id
			}
			if(this.project_line_id){
				data.relatable_type = 'project_line'
				data.relatable_id = this.project_line_id
			}
			const formData = new FormData()
			Object.keys(data).forEach((key) => {
				if(data[key]) {
					formData.append(key, data[key])
				}
			})
			
			this.new_message = null
			const new_message = await addMessageToChatRoom(formData)
			if(new_message.code == 200){
				this.conversationMessages = new_message.chat_room_messages?.messages
				this.$store.dispatch('chats/getUserChats')
				this.getSelectedChatRoomMessages()
				this.closeFilePreview()
			}
		},
		getIconFile(file){
			const fileExtension = file.path.split('.').pop().toLowerCase();
			if (fileExtension === 'pdf') {
					return { icon: 'mdi-file-pdf-box', color: '#FF0000' };
			} else if (fileExtension === 'doc' || fileExtension === 'docx') {
					return { icon: 'mdi-file-word', color: '#1E88E5' };
			} else if (fileExtension === 'xls' || fileExtension === 'xlsx') {
					return { icon: 'mdi-file-excel', color: '#4CAF50' };
			} else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(fileExtension)) {
					return { icon: 'mdi-file-image', color: '#FFD700' };
			} else {
					return { icon: 'mdi-file', color: '#9E9E9E' };
			}
		},
		showFilePicker() {
			const input = this.$refs.fileInput;
			input.onchange = async (event) => {
				const file = event.target.files[0]
				this.fileToUpload = file
				input.value = null
			};
			input.click();
		},
		isMyMessage(message){
			return message.user_id == this.$store.state.user?.userInfo?.id
		},
		async markMessagesAsSeenBatch(messageIds) {
			try {
				await markMessagesAsSeen({
					chat_room_id: this.selectedChatRoomId,
					message_ids: messageIds
				});
				this.reloadChatRoom();
				this.$store.dispatch('chats/getUserChats')
			} catch (error) {
				console.log('Error marking messages as seen:', error);
			}
		},
		async getSelectedChatRoomMessages(){
			this.closeFilePreview()
			this.showAllMessages = false
			const chat_room_id = this.selectedChatRoomId
			const messages = await getChatRoomMessages({chat_room_id, project_line_id: this.project_line_id})
			this.loadingRoomMessages = false
			if(messages.code == 200){
				this.conversationMessages = messages.chat_room?.messages;
				this.chatRoom = messages.chat_room;
				this.userProjects = messages.user_projects;
				if(this.chatRoom?.users && this.chatRoom.users.length > 0) {
					this.assignColorsToUsers(this.chatRoom.users)
				}
			}
			else if(messages.code == 403){
				this.$store.dispatch('chats/getUserChats')
				this.$emit('clearSelectedRoom')
				const messageData = {
					message: 'No tienes acceso a este chat',
					title: 'Sin acceso',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		async sendMessage(){
			if(this.new_message || this.fileToUpload){
				this.appendNewMessageTemp(this.new_message)
				const data = {
					chat_room_id: this.selectedChatRoomId,
					message: this.new_message,
					file: this.fileToUpload
				}
				if(this.project_line_id){
					data.relatable_type = 'project_line'
					data.relatable_id = this.project_line_id
				}
        const formData = new FormData()
        Object.keys(data).forEach((key) => {
          if(data[key]) {
            formData.append(key, data[key])
          }
        })
				this.new_message = null
				const new_message = await addMessageToChatRoom(formData)
				if(new_message.code == 200){
					this.conversationMessages = new_message.chat_room_messages?.messages
					this.$store.dispatch('chats/getUserChats')
					this.getSelectedChatRoomMessages()
					this.closeFilePreview()
				}
			}
		},
		appendNewMessageTemp(message){
			let add_message = {
				message,
				user: {
					name: this.$store.state.user?.userInfo?.profile?.name,
					lastname: this.$store.state.user?.userInfo?.profile?.lastname,
					second_lastname: this.$store.state.user?.userInfo?.profile?.second_lastname,
				},
				user_id: this.$store.state.user?.userInfo?.id
			}
			if(this.project_line_id){
				add_message.relatable = {
					relatable_id: this.project_line_id
				}
			}
			this.conversationMessages.push(add_message)
		},
		async fileToItem(file_id){
			const data = {
				chat_room_id: this.selectedChatRoomId,
				file_id
			}
			try {
				await chatFileToItem(data)
				this.getSelectedChatRoomMessages()
				const messageData = {
					message: 'Se ha asociado el archivo al preproyecto',
					title: 'Archivo guardado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			} catch (error) {
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		async deleteChatMessage(message_id){
			const messageIndex = this.conversationMessages.findIndex(msg => msg.id === message_id)
			const originalMessage = messageIndex >= 0 ? { ...this.conversationMessages[messageIndex] } : null
			
			if (messageIndex >= 0) {
				this.conversationMessages.splice(messageIndex, 1)
			}
			
			try {
				await deleteMessageFromChatRoom({message_id})
			} catch (error) {
				if (originalMessage && messageIndex >= 0) {
					this.conversationMessages.splice(messageIndex, 0, originalMessage)
				}
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
	},
};
</script>

<style scoped>
	.relatable-header {
		padding: 10px;
		margin-top: 8px;
		margin-bottom: 4px;
	}
	.relatable-chip {
		display: flex;
		align-items: center;
		gap: 4px;
	}
	.chat-container{
		flex: 1;
	}
	.chat-list-item{
		cursor: pointer;
	}
	.chat-list-item:hover{
		background: #FCFBFE;
	}

	.v-text-field {
		align-items: center;
	}
	.chatbox-container{
		display: flex;
		flex-direction: column;
		background: white;
	}
	.messages-container{
		display: flex;
		flex-direction: column;
		padding: 10px;
		flex: 1;
		background-color: #FCFBFE;
		text-transform: none;
	}
	.chat-room-header,
	.user-input-container{
		flex: 0;
		background-color: #e9e9e9;
	}
	.hidden-messages-bar {
		flex: 0;
		background-color: #fff3cd;
		border-top: 1px solid #ffc107;
		border-bottom: 1px solid #ffc107;
	}
	.user-input-inner-container{
		padding: 10px;
	}
	.single-message{
		background-color: rgb(237, 237, 237);
		border: 1px solid rgb(193, 191, 191);
		padding: 4px 8px;
		max-width: 80%;
		border-radius: 10px;
		font-size: 14px;
		text-transform: none;
	}
	.single-message.self-user{
		background-color: rgb(217, 239, 217);
		border: 1px solid rgb(197, 232, 197);
		align-self: flex-end;
	}
	.chatbox-container .single-message p{
		margin-bottom: 0;
		word-break: break-word;
		overflow-wrap: break-word;
		word-wrap: break-word;
		white-space: normal;
		max-width: 100%;
	}
	.single-message .d-flex {
		min-width: 0;
	}
	.nomessages{
		text-align: center;
		font-size: 14px;
		padding-top: 30px;
	}
	.chat-file-container{
		cursor: pointer;
		background: rgba(0,0,0,0.1);
	}
	.chat-image-container{
		cursor: pointer;
	}
	.custom-badge-counter-chat{
		position: absolute;
		top: -15px;
		right: -8px;
		background-color: green;
		z-index: 100;
		border-radius: 50%;
		width: 20px;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.system-message{
		font-size: 11px;
		color: #555;
		background-color: #f0f0f0;
		border: 1px solid #ddd;
		border-radius: 5px;
		padding: 2px 8px;
		gap: 4px;
		width: fit-content;
		margin: auto;
	}
	.system-message-date{
		position: absolute;
		right: 0;
		left: 0;
		bottom: -4px;
		width: 80px;
		font-size: 10px;
		margin: auto;
		text-align: center;
		background-color: #f0f0f0;
		border: 1px solid #ddd;
		border-radius: 5px;
	}
</style>
<style>
	.chatbox-container .single-message p{
		margin-bottom: 0;
	}
</style>